export default __webpack_public_path__ + "static/media/right-min.1d927cb3.gif";